import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import enGB from "./locales/en-GB/translation.json";
import enUS from "./locales/en-US/translation.json";
import es from "./locales/es/translation.json";

export const SUPPORTED_LANGUAGES = [
  { value: "en-GB", label: "English (UK)" },
  { value: "en-US", label: "English (US)" },
  { value: "es", label: "Español" },
] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]["value"];

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      "en-GB": { translation: enGB },
      "en-US": { translation: enUS },
      es: { translation: es },
    },
    fallbackLng: "en-GB",
    supportedLngs: ["en-GB", "en-US", "es"],
    load: "currentOnly",
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "pme-hr-lang",
    },
  });

/** Apply the language stored on an employee record, if different from now. */
export function applyLanguage(preferred: string | null | undefined): void {
  if (!preferred) return;
  if (i18n.language === preferred) return;
  void i18n.changeLanguage(preferred);
  try {
    window.localStorage.setItem("pme-hr-lang", preferred);
  } catch {
    // ignore storage errors
  }
}

export default i18n;
